import Fullscreen from "@coworker/apprestructured/src/task-management/components/Fullscreen/Fullscreen";
import FullscreenContent from "@coworker/apprestructured/src/task-management/components/Fullscreen/FullscreenContent/FullscreenContent";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import Breadcrumb from "../../shared/Breadcrumb/Breadcrumb";
import CompletableChecklistDemo from "../ComponentDemoPage/demos/CompletableChecklistDemo";
import LogsAndCommentsDemo from "../ComponentDemoPage/demos/LogsAndCommentsDemo";
import PersonAndTeamDemo from "../ComponentDemoPage/demos/PersonAndTeamDemo";
import TitledBoxedTextDemo from "../ComponentDemoPage/demos/TitledBoxedTextDemo";
import TitledBoxedTextWithModalDemo from "../ComponentDemoPage/demos/TitledBoxedTextWithModalDemo";
import TitledTextAreaViewerFragmentDemo from "../ComponentDemoPage/demos/TitledTextAreaViewerFragmentDemo";
import TitledHeadingTextViewerTopFragmentDemo from "../ComponentDemoPage/demos/TitledHeadingTextViewerTopFragmentDemo";
import MediaLocationsViewerFragmentDemo from "../ComponentDemoPage/demos/MediaLocationsViewerFragmentDemo";
import TaskInfoPanelDemo from "../ComponentDemoPage/demos/TaskInfoPanelDemo";
import FailureRatingDemo from "../ComponentDemoPage/demos/FailureRatingDemo";
import BannerFieldCardFragmentDemo from "../ComponentDemoPage/demos/BannerFieldCardFragmentDemo";
import BannerTitleAndFieldCardFragmentDemo from "../ComponentDemoPage/demos/BannerTitleAndFieldCardFragmentDemo";
import MarkAsCompleteCreatorFragmentDemo from "../ComponentDemoPage/demos/MarkAsCompleteCreatorFragmentDemo";
import TabTitleContentViewerFragmentDemo from "../ComponentDemoPage/demos/TabTitleContentViewerFragmentDemo";
import ProgressViewerFragmentDemo from "../ComponentDemoPage/demos/ProgressViewerFragmentDemo";
import GroupedViewerFragmentDemo from "../ComponentDemoPage/demos/GroupedViewerFragmentDemo";
import styles from "../shared.module.css";
import TitledTextWithBadgesDemo from "../ComponentDemoPage/demos/TitledTextWithBadgesDemo";

function ViewerComponentsPage() {
  return (
    <Fullscreen>
      <Linkbar currentLabel="ViewerComponents" currentAsH1 />
      <FullscreenContent className={styles["content"]}>
        <Breadcrumb
          items={[
            { label: "Components", path: "/task-management-components" },
            { label: "ViewerComponents" },
          ]}
        />

        <FixaText tagName="h2" textStyle="Heading.XL">
          ViewerComponents
        </FixaText>

        <CompletableChecklistDemo />
        <LogsAndCommentsDemo />
        <PersonAndTeamDemo />
        <TitledBoxedTextDemo />
        <TitledTextWithBadgesDemo />
        <TitledBoxedTextWithModalDemo />
        <TitledTextAreaViewerFragmentDemo />
        <TitledHeadingTextViewerTopFragmentDemo />
        <MediaLocationsViewerFragmentDemo />
        <TaskInfoPanelDemo />
        <FailureRatingDemo />
        <MarkAsCompleteCreatorFragmentDemo />
        <TabTitleContentViewerFragmentDemo />
        <ProgressViewerFragmentDemo />
        <GroupedViewerFragmentDemo />
        <BannerFieldCardFragmentDemo />
        <BannerTitleAndFieldCardFragmentDemo />
      </FullscreenContent>
    </Fullscreen>
  );
}

export default ViewerComponentsPage;
